import { useVideo } from "../providers/VideoContext";

/**
 * Custom hook to access active speaker functionality
 * @returns Object with active speakers data and utility functions
 */
export const useActiveSpeakers = () => {
  const { activeSpeakers } = useVideo();

  /**
   * Check if a specific attendee is currently an active speaker
   * @param attendeeId - The attendee ID to check
   * @returns boolean indicating if the attendee is an active speaker
   */
  const isActiveSpeaker = (attendeeId: string): boolean => {
    return activeSpeakers.includes(attendeeId);
  };

  /**
   * Get the count of currently active speakers
   * @returns number of active speakers
   */
  const getActiveSpeakerCount = (): number => {
    return activeSpeakers.length;
  };

  /**
   * Check if there are any active speakers
   * @returns boolean indicating if there are any active speakers
   */
  const hasActiveSpeakers = (): boolean => {
    return activeSpeakers.length > 0;
  };

  return {
    activeSpeakers,
    isActiveSpeaker,
    getActiveSpeakerCount,
    hasActiveSpeakers,
  };
};
